import { authenticatedFetch } from './authenticatedFetch';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';
const VISITOR_KEY = 'hammerly_visitor_id';
let visitorId: string | undefined;

function getVisitorId(): string {
  if (visitorId) return visitorId;
  try {
    const stored = localStorage.getItem(VISITOR_KEY);
    if (stored && /^[A-Za-z0-9_-]{1,128}$/.test(stored)) visitorId = stored;
  } catch { /* Storage may be disabled; retain an ID in memory for this load. */ }
  if (!visitorId) {
    visitorId = crypto.randomUUID();
    try {
      localStorage.setItem(VISITOR_KEY, visitorId);
    } catch { /* Tracking must not depend on storage being available. */ }
  }
  return visitorId;
}

export async function trackPageView(path: string): Promise<void> {
  try {
    await authenticatedFetch(`${API_BASE_URL}/analytics/view`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, visitorId: getVisitorId() }),
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      keepalive: true,
    }, { accessToken: null, clearSessionOnUnauthorized: false });
  } catch { /* Best effort: no retries, notifications, or changes to the user session. */ }
}
